import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [{
	path: '/',
	redirect: '/index',
	component: resolve => (require(["@/views/layout"], resolve)),
	children: [
		{
			path: '/index',
			meta: {
				title: '首页'
			},
			component: resolve => (require(['@/pages/index'], resolve))
		},
		{
			path: '/businessIntro',
			meta: {
				title: '业务简介'
			},
			component: resolve => (require(['@/pages/businessIntro'], resolve))
		},
		{
			path: '/gardenIntroduction',
			meta: {
				title: '园区介绍'
			},
			component: resolve => (require(['@/pages/gardenIntroduction'], resolve))
		},
		{
			path: '/wisdomGarden',
			meta: {
				title: '智慧园区'
			},
			component: resolve => (require(['@/pages/wisdomGarden'], resolve))
		},
		{
			path: '/teamIntroduction',
			meta: {
				title: '团队介绍'
			},
			component: resolve => (require(['@/pages/teamIntroduction'], resolve))
		}
	]
}]
export default new VueRouter({
	model: 'history',
	routes
})